import {styled, Box} from '@mui/material';

export const Container = styled(Box)`

`;